"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureInputs = ensureInputs;
function ensureInputs(inputs) {
    if (!inputs) {
        throw new Error("inputs is undefined"); // should never happen
    }
    return inputs;
}
//# sourceMappingURL=utils.js.map